import { IModel } from '@/@types/models/model';
import coreFields from './helpers/coreFields';

const AktivnostiOdržavanja: IModel = {
  title: 'Aktivnosti održavanja',
  apiPath: 'cestovna-infrastruktura/maintenance-activities',
  forms: {
    default: {
      fields: [
        'path_id',
        'type_id',
        'km',
        'date_from',
        'date_to',
        'description',
      ],
    }
  },
  listViews: {
    default: {
      fields: [
        'id',
        'type_id',
        'date_from',
        'date_to',
        'km',
        'description',
      ],
      hidden: ['id'],
    },
  },
  fields: [
    coreFields.id,
    {
      title: 'path_id',
      source: 'path_id',
      ttoken: 'cestovna_infrastruktura:ceste_putevi.cesta_put',
      type: 'picker',
      subModel: {
        apiPath: 'cestovna-infrastruktura/paths',
        format: '{label}',
        idattr: 'id'
      },
      width: 'full',
      validation: {
        required: true,
      },
      filter: true,
    },
    {
      title: 'type_id',
      source: 'type_id',
      ttoken: 'cestovna_infrastruktura:aktivnost.vrsta',
      type: 'picker',
      subModel: {
        apiPath: 'cestovna-infrastruktura/maintenance-activities-types',
        format: '{label}',
        idattr: 'id'
      },
      validation: {
        required: true,
      },
      translate: true,
      filter: true,
    },
    {
      title: 'description',
      source: 'description',
      ttoken: 'cestovna_infrastruktura:aktivnost.opis',
      type: 'multiline',
      rows: 2,
      maxRows: 3,
      width: 'full',
      validation: {
        required: true,
      },
    },
    {
      title: 'km',
      source: 'km',
      ttoken: 'cestovna_infrastruktura:aktivnost.km',
      type: 'numeric',
      filter: true,
    },
    {
      title: 'date_from',
      source: 'date_from',
      ttoken: 'cestovna_infrastruktura:aktivnost.datum_od',
      type: 'date',
      validation: {
        required: true,
      },
      filter: true,
    },
    {
      title: 'date_to',
      source: 'date_to',
      ttoken: 'cestovna_infrastruktura:aktivnost.datum_do',
      type: 'date',
      validation: {
        isAfter: {
          source: 'date_from', 
          ttoken: 'cestovna_infrastruktura:aktivnost.datum_od'
        }
      },
      filter: true,
    },
    coreFields.created_by,
    coreFields.created_on,
    coreFields.modified_by,
    coreFields.modified_on,
    {
      title: 'Geometry',
      source: 'geom',
      ttoken: 'common.geometry',
      type: 'wkt',
      sourceProjection: 'EPSG:3857',
      targetProjection: 'EPSG:3857',
      readonly: true,
    },
  ],
};

export default AktivnostiOdržavanja;
